import { DepositAccountDataState } from '@banking/ui/workflows/card-settings';
import { ControlType } from '@banking/ui/components/banking/checking/card-settings/management/setting';
import assert from '@banking/ui/utils/assert';
import { Relationship } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { windowMocks } from '@square/dashboard-utilities/utils/window';
const CHECKING_OWNERSHIP_LETTER_URL = '/v1/accountownershipletter';
const BANKING_ACCOUNT_OWNERSHIP_LETTER_URL = '/v3/bank-accounts/legal/account-ownership-letter';
export const getStatementsSetting = (t, unitToken, transitionTo) => () => {
  return {
    icon: '24px-bar-graph',
    text: t('banking.checking.cardSettings.page.settings.statements'),
    control: {
      type: ControlType.Regular,
      action: () => transitionTo('statements', {
        queryParams: {
          unitToken
        }
      })
    }
  };
};
export const getAccountOwnershipLetterSetting = (t, unitToken, isFeatureEnabled) => () => {
  return {
    icon: 'download-file',
    text: t('banking.checking.cardSettings.page.settings.downloadOwnershipLetter'),
    control: {
      type: ControlType.Regular,
      action: () => {
        if (isFeatureEnabled('banking-accounts/use_banking_account_ownership_letter_url')) {
          windowMocks.open(`${BANKING_ACCOUNT_OWNERSHIP_LETTER_URL}?unit_token=${unitToken}`);
        } else {
          windowMocks.open(`${CHECKING_OWNERSHIP_LETTER_URL}?unitToken=${unitToken}`);
        }
      }
    }
  };
};
export const getDocumentSettings = (t, isFeatureEnabled, unitToken, transitionTo) => state => {
  if (state.loading || !isFeatureEnabled('banking/access_statements')) {
    return [];
  }
  assert(state.card != null);
  if (!state.card.relationship.includes(Relationship.RELATIONSHIP_ACCOUNT_HOLDER) || !state.card.relationship.includes(Relationship.RELATIONSHIP_CARDHOLDER)) {
    return [];
  }
  const settings = [getStatementsSetting(t, unitToken, transitionTo)()];
  if (state.depositAccountData === DepositAccountDataState.HAS_DEPOSIT_ACCOUNT) {
    settings.push(getAccountOwnershipLetterSetting(t, unitToken, isFeatureEnabled)());
  }
  return settings;
};